/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const DocumentosExtrasByTipoDocumentoAndFechaUuid = /* GraphQL */ `
  query DocumentosExtrasByTipoDocumentoAndFechaUuid(
    $fecha_uuid: ModelStringKeyConditionInput
    $filter: ModelDocumentosExtrasFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $tipoDocumento: String!
  ) {
    DocumentosExtrasByTipoDocumentoAndFechaUuid(
      fecha_uuid: $fecha_uuid
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      tipoDocumento: $tipoDocumento
    ) {
      items {
        createdAt
        fechaFirmaRepresentante
        fechaFirmaTrabajador
        fecha_uuid
        firmadoRepresentanteLegal
        firmadoTrabajador
        ofertaId
        tipoDocumento
        trabajadorId
        updatedAt
        urlDocumento
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const HistoricoTrabajadorByTrabajadorId = /* GraphQL */ `
  query HistoricoTrabajadorByTrabajadorId(
    $filter: ModelHistoricoTrabajadorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $trabajadorId: String!
  ) {
    HistoricoTrabajadorByTrabajadorId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      trabajadorId: $trabajadorId
    ) {
      items {
        contadorTrabajos
        createdAt
        duracionUltimoTrabajo
        empresaId
        fechaUltimoTrabajo
        nombreCortoTipoTrabajo
        razonSocialUltimoTrabajo
        trabajadorId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const OfertaTrabajoByEstadoActual = /* GraphQL */ `
  query OfertaTrabajoByEstadoActual(
    $estadoActual: String!
    $filter: ModelOfertaTrabajoFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    OfertaTrabajoByEstadoActual(
      estadoActual: $estadoActual
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        brutoTotal
        causalContrado
        colacion
        costoNeto
        costoServicio
        createdAt
        descripcionTipoTrabajo
        empresaId
        estadoActual
        facturadoRealFinal
        fechaCaducidad
        fechaFin
        firmaContrato
        historialEstados
        idOferta
        identificadorTributario
        infoOnboarding
        isPublic
        liquidoTotal
        multimediaOfertaId
        nombreContrato
        nombreReemplazado
        nuevosPostulantes
        pais_consecutivoOferta
        provisionFondos
        razonSocial
        rubro
        rutReemplazado
        tipo
        tipoTrabajo
        totalHoras
        totalVacantes
        transporte
        turnos
        ubicacion
        updatedAt
        usuariosInvitados
        valorGratificacion
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const OfertaTrabajoByTipo = /* GraphQL */ `
  query OfertaTrabajoByTipo(
    $filter: ModelOfertaTrabajoFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $tipo: String!
  ) {
    OfertaTrabajoByTipo(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      tipo: $tipo
    ) {
      items {
        brutoTotal
        causalContrado
        colacion
        costoNeto
        costoServicio
        createdAt
        descripcionTipoTrabajo
        empresaId
        estadoActual
        facturadoRealFinal
        fechaCaducidad
        fechaFin
        firmaContrato
        historialEstados
        idOferta
        identificadorTributario
        infoOnboarding
        isPublic
        liquidoTotal
        multimediaOfertaId
        nombreContrato
        nombreReemplazado
        nuevosPostulantes
        pais_consecutivoOferta
        provisionFondos
        razonSocial
        rubro
        rutReemplazado
        tipo
        tipoTrabajo
        totalHoras
        totalVacantes
        transporte
        turnos
        ubicacion
        updatedAt
        usuariosInvitados
        valorGratificacion
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const PreferenciasNotificacionesByTipoTrabajo = /* GraphQL */ `
  query PreferenciasNotificacionesByTipoTrabajo(
    $filter: ModelPreferenciasNotificacionesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $tipoTrabajo: String!
  ) {
    PreferenciasNotificacionesByTipoTrabajo(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      tipoTrabajo: $tipoTrabajo
    ) {
      items {
        createdAt
        tipoTrabajo
        tipoTrabajo_ubicacion
        trabajadorId
        ubicacion
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const PreferenciasNotificacionesByUbicacion = /* GraphQL */ `
  query PreferenciasNotificacionesByUbicacion(
    $filter: ModelPreferenciasNotificacionesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $ubicacion: String!
  ) {
    PreferenciasNotificacionesByUbicacion(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      ubicacion: $ubicacion
    ) {
      items {
        createdAt
        tipoTrabajo
        tipoTrabajo_ubicacion
        trabajadorId
        ubicacion
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const RegistroIncidentesByTrabajadorId = /* GraphQL */ `
  query RegistroIncidentesByTrabajadorId(
    $filter: ModelRegistroIncidentesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $trabajadorId: String!
  ) {
    RegistroIncidentesByTrabajadorId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      trabajadorId: $trabajadorId
    ) {
      items {
        coordenadas
        createdAt
        descripcion
        fecha
        fechaMarcaje
        fechaServidor
        pais
        posicionCorrecta
        tipo
        trabajadorId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const ReporteBackofficeByEstadoActual = /* GraphQL */ `
  query ReporteBackofficeByEstadoActual(
    $estadoActual: String!
    $filter: ModelReporteBackofficeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    ReporteBackofficeByEstadoActual(
      estadoActual: $estadoActual
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        calleTrabajador
        calleUsuaria
        cargo
        comunaTrabajador
        comunaUsuaria
        contratoId
        createdAt
        deptoTrabajador
        detalleTurnos
        empresaId
        estadoActual
        estadoContrato
        estadoContratoAnpd
        fechaContrato
        liquidoPago
        montoImponible
        montoNoImponible
        nacionalidad
        nombreContrato
        nroCalleTrabajador
        nroUsuaria
        pais_consecutivoOferta_trabajadorId
        regionTrabajador
        regionUsuaria
        rutTrabajador
        rutUsuaria
        sueldoBase
        telefonoTrabajador
        totalHoras
        trabajadorId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const ReporteBackofficeByTrabajadorId = /* GraphQL */ `
  query ReporteBackofficeByTrabajadorId(
    $filter: ModelReporteBackofficeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $trabajadorId: String!
  ) {
    ReporteBackofficeByTrabajadorId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      trabajadorId: $trabajadorId
    ) {
      items {
        calleTrabajador
        calleUsuaria
        cargo
        comunaTrabajador
        comunaUsuaria
        contratoId
        createdAt
        deptoTrabajador
        detalleTurnos
        empresaId
        estadoActual
        estadoContrato
        estadoContratoAnpd
        fechaContrato
        liquidoPago
        montoImponible
        montoNoImponible
        nacionalidad
        nombreContrato
        nroCalleTrabajador
        nroUsuaria
        pais_consecutivoOferta_trabajadorId
        regionTrabajador
        regionUsuaria
        rutTrabajador
        rutUsuaria
        sueldoBase
        telefonoTrabajador
        totalHoras
        trabajadorId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const TrabajadorByDni = /* GraphQL */ `
  query TrabajadorByDni(
    $dni: String!
    $filter: ModelTrabajadorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    TrabajadorByDni(
      dni: $dni
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        activo
        banco
        calificacionPromedio
        calle
        canalesNotificaciones
        ciudad
        clave
        comuna
        correo
        createdAt
        depto
        descripcion
        direccion
        dni
        enlaceFoto
        estId
        fechaNacimiento
        firebaseToken
        idBanco
        nacionalidad
        noCuentaBancaria
        nombre
        numero
        origen
        pais
        primerApellido
        region
        segundaClave
        segundoApellido
        sexo
        telefono
        tipoCuenta
        ultimaFechaConsultaAnuncios
        updatedAt
        uuid
        validadoXEST
        validarDocumentos
        visibilidadFoto
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const TrabajadorCalendarioByEmpresaIdAndPaisConsecutivoOferta = /* GraphQL */ `
  query TrabajadorCalendarioByEmpresaIdAndPaisConsecutivoOferta(
    $empresaId: String!
    $filter: ModelTrabajadorCalendarioFilterInput
    $limit: Int
    $nextToken: String
    $pais_consecutivoOferta: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    TrabajadorCalendarioByEmpresaIdAndPaisConsecutivoOferta(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_consecutivoOferta: $pais_consecutivoOferta
      sortDirection: $sortDirection
    ) {
      items {
        aprobado
        cargoId
        confirmado
        createdAt
        detalleModificacionTurno
        duracion
        empresaId
        entrada
        estadoAprobacion
        estadoEntrada
        estadoSalida
        fechaFin
        fecha_empresaId_pais_consecutivoOferta
        llegada
        pais_consecutivoOferta
        primerDiaContrato
        salida
        timeZone
        trabajadorId
        turno
        ubicacionId
        ultimoDia
        ultimoDiaContrato
        unidad
        updatedAt
        valorUnitario
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const TrabajadorCalendarioByTrabajadorId = /* GraphQL */ `
  query TrabajadorCalendarioByTrabajadorId(
    $trabajadorId: String!
    $filter: ModelTrabajadorCalendarioFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    TrabajadorCalendarioByTrabajadorId(
      trabajadorId: $trabajadorId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        aprobado
        cargoId
        confirmado
        createdAt
        detalleModificacionTurno
        duracion
        empresaId
        entrada
        estadoAprobacion
        estadoEntrada
        estadoSalida
        fechaFin
        fecha_empresaId_pais_consecutivoOferta
        llegada
        pais_consecutivoOferta
        primerDiaContrato
        salida
        timeZone
        trabajadorId
        turno
        ubicacionId
        ultimoDia
        ultimoDiaContrato
        unidad
        updatedAt
        valorUnitario
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const TrabajadorPagoByEmpresaIdPaisConsecutivoOferta = /* GraphQL */ `
  query TrabajadorPagoByEmpresaIdPaisConsecutivoOferta(
    $empresaId_pais_consecutivoOferta: String!
    $filter: ModelTrabajadorPagoFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    TrabajadorPagoByEmpresaIdPaisConsecutivoOferta(
      empresaId_pais_consecutivoOferta: $empresaId_pais_consecutivoOferta
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        concepto
        createdAt
        empresaId_pais_consecutivoOferta
        fecha_uuid
        historialPagoId
        trabajadorId
        updatedAt
        valor
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const TrabajadorPagoByhistorialPagoId = /* GraphQL */ `
  query TrabajadorPagoByhistorialPagoId(
    $filter: ModelTrabajadorPagoFilterInput
    $historialPagoId: String!
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    TrabajadorPagoByhistorialPagoId(
      filter: $filter
      historialPagoId: $historialPagoId
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        concepto
        createdAt
        empresaId_pais_consecutivoOferta
        fecha_uuid
        historialPagoId
        trabajadorId
        updatedAt
        valor
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const TransaccionByCorreo = /* GraphQL */ `
  query TransaccionByCorreo(
    $correo: AWSEmail!
    $filter: ModelTransaccionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    TransaccionByCorreo(
      correo: $correo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        correo
        createdAt
        detalle
        empresaId
        fecha_uuid
        monto
        observacion
        tipo
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const detalleFacturacionByTrabajadorIdAndEmpresaIdPaisConsecutivoOferta = /* GraphQL */ `
  query DetalleFacturacionByTrabajadorIdAndEmpresaIdPaisConsecutivoOferta(
    $empresaId_paisConsecutivoOferta: ModelStringKeyConditionInput
    $filter: ModelDetalleFacturacionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $trabajadorId: String!
  ) {
    detalleFacturacionByTrabajadorIdAndEmpresaIdPaisConsecutivoOferta(
      empresaId_paisConsecutivoOferta: $empresaId_paisConsecutivoOferta
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      trabajadorId: $trabajadorId
    ) {
      items {
        aprobadoPor
        createdAt
        dni
        duracion
        empresaId
        empresaId_paisConsecutivoOferta
        estadoAprobacion
        estadoEntrada
        estadoFacturacion
        estadoSalida
        factorMultiplicador
        facturacion
        fechaFin
        fechaInicio
        fecha_pais_consecutivoOferta_trabajadorId
        nombre
        primerApellido
        registroEntradaPor
        registroSalidaPor
        segundoApellido
        tipoTrabajo
        trabajadorId
        unidad
        updatedAt
        valorAFacturar
        valorAPagar
        valorBruto
        valorContribucion
        valorIVA
        valorImposicion
        valorLiquidado
        valorNeto
        valorPresupuestado
        valorUnitario
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dtIndex = /* GraphQL */ `
  query DtIndex(
    $dtIndex: String!
    $fechaContrato: ModelStringKeyConditionInput
    $filter: ModelTrabajadorOfertaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    dtIndex(
      dtIndex: $dtIndex
      fechaContrato: $fechaContrato
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        cartaAviso
        contratoEmpresa
        contratoId
        createdAt
        cumplimientoRequisito
        dtIndex
        empresaId
        empresaId_pais_consecutivoOferta
        estadoActual
        estadoContrato
        estadoContratoAnpd
        fechaContrato
        hashRepLegal
        hashTrabajador
        historialEstados
        historialEstadosContrato
        historialEstadosContratoAnpd
        infoOnboardingLeida
        origenPostulacion
        pais_consecutivoOferta_trabajadorId
        pathContratos
        pathContratosCliente
        trabajadorId
        turnos
        turnosExtra
        updatedAt
        valorAPagar
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const empresaEtiquetaTrabajadorByTrabajadorIdAndEmpresaIdEtiquetaId = /* GraphQL */ `
  query EmpresaEtiquetaTrabajadorByTrabajadorIdAndEmpresaIdEtiquetaId(
    $empresaId_etiquetaId: ModelStringKeyConditionInput
    $filter: ModelEmpresaEtiquetaTrabajadorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $trabajadorId: String!
  ) {
    empresaEtiquetaTrabajadorByTrabajadorIdAndEmpresaIdEtiquetaId(
      empresaId_etiquetaId: $empresaId_etiquetaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      trabajadorId: $trabajadorId
    ) {
      items {
        createdAt
        empresaId
        empresaId_etiquetaId
        etiquetaId_trabajadorId
        trabajadorId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBackground = /* GraphQL */ `
  query GetBackground($tipo_uuid: String!, $trabajadorId: String!) {
    getBackground(tipo_uuid: $tipo_uuid, trabajadorId: $trabajadorId) {
      anoInicio
      cargoTitulo
      createdAt
      descripcion
      duracionMeses
      institucion
      tipo_uuid
      trabajadorId
      updatedAt
      validadoXEST
      __typename
    }
  }
`;
export const getCalificacion = /* GraphQL */ `
  query GetCalificacion(
    $empresaId: String!
    $pais_consecutivoOferta_trabajadorId: String!
  ) {
    getCalificacion(
      empresaId: $empresaId
      pais_consecutivoOferta_trabajadorId: $pais_consecutivoOferta_trabajadorId
    ) {
      createdAt
      detalles
      empresaId
      fecha
      pais_consecutivoOferta_trabajadorId
      tipo
      updatedAt
      __typename
    }
  }
`;
export const getComentariosCambiosTrabajador = /* GraphQL */ `
  query GetComentariosCambiosTrabajador(
    $fecha: AWSDateTime!
    $trabajadorId: String!
  ) {
    getComentariosCambiosTrabajador(
      fecha: $fecha
      trabajadorId: $trabajadorId
    ) {
      comentario
      createdAt
      fecha
      trabajadorId
      updatedAt
      __typename
    }
  }
`;
export const getComentariosOfertaTrabajo = /* GraphQL */ `
  query GetComentariosOfertaTrabajo(
    $empresaId: String!
    $pais_consecutivoOferta_fecha: String!
  ) {
    getComentariosOfertaTrabajo(
      empresaId: $empresaId
      pais_consecutivoOferta_fecha: $pais_consecutivoOferta_fecha
    ) {
      comentario
      createdAt
      empresaId
      pais_consecutivoOferta_fecha
      updatedAt
      __typename
    }
  }
`;
export const getComunaTipoTrabajoRecomendaciones = /* GraphQL */ `
  query GetComunaTipoTrabajoRecomendaciones(
    $pais: String!
    $region_ciudad_comuna_rubro_tipoTrabajo: String!
  ) {
    getComunaTipoTrabajoRecomendaciones(
      pais: $pais
      region_ciudad_comuna_rubro_tipoTrabajo: $region_ciudad_comuna_rubro_tipoTrabajo
    ) {
      createdAt
      pais
      region_ciudad_comuna_rubro_tipoTrabajo
      rubro_tipoTrabajo
      updatedAt
      valorMaxRecomendado
      valorMinLegal
      valorMinRecomendado
      __typename
    }
  }
`;
export const getConfiguracionEmpresa = /* GraphQL */ `
  query GetConfiguracionEmpresa($empresaId: ID!) {
    getConfiguracionEmpresa(empresaId: $empresaId) {
      cargos
      contratos
      createdAt
      empresaId
      postulacion
      updatedAt
      __typename
    }
  }
`;
export const getContador = /* GraphQL */ `
  query GetContador($empresaId: String!, $pais_consecutivoOferta: String!) {
    getContador(
      empresaId: $empresaId
      pais_consecutivoOferta: $pais_consecutivoOferta
    ) {
      aceptadoXEmpresa
      aceptadoXTrabajador
      aceptadosTurno
      contratoAnuladoXBackoffice
      contratoAnuladoXEmpresa
      contratoAnuladoXTrabajador
      contratoCerrado
      createdAt
      descartadoXEmpresa
      desistidaXTrabajador
      ejecutando
      empresaId
      pais_consecutivoOferta
      postulado
      provisionadoXEmpresa
      rechazadoXEmpresa
      rechazadoXTrabajador
      seleccionadoXEmpresa
      seleccionadosTurno
      terminado
      updatedAt
      validado
      visitasUsuarioAutenticado
      visitasUsuarioNoAutenticado
      __typename
    }
  }
`;
export const getContrato = /* GraphQL */ `
  query GetContrato(
    $empresaId: String!
    $pais_consecutivoOferta_uuid: String!
  ) {
    getContrato(
      empresaId: $empresaId
      pais_consecutivoOferta_uuid: $pais_consecutivoOferta_uuid
    ) {
      cantidadPersonasAContratar
      createdAt
      empresaId
      estadoActual
      historialEstados
      pais_consecutivoOferta_uuid
      updatedAt
      __typename
    }
  }
`;
export const getContratoPendiente = /* GraphQL */ `
  query GetContratoPendiente(
    $empresaId: String!
    $pais_consecutivoOferta_uuid: String!
  ) {
    getContratoPendiente(
      empresaId: $empresaId
      pais_consecutivoOferta_uuid: $pais_consecutivoOferta_uuid
    ) {
      createdAt
      empresaId
      pais_consecutivoOferta_uuid
      updatedAt
      __typename
    }
  }
`;
export const getCredenciales = /* GraphQL */ `
  query GetCredenciales($apiKey: ID!) {
    getCredenciales(apiKey: $apiKey) {
      activa
      apiKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getDetalleFacturacion = /* GraphQL */ `
  query GetDetalleFacturacion(
    $empresaId: String!
    $fecha_pais_consecutivoOferta_trabajadorId: String!
  ) {
    getDetalleFacturacion(
      empresaId: $empresaId
      fecha_pais_consecutivoOferta_trabajadorId: $fecha_pais_consecutivoOferta_trabajadorId
    ) {
      aprobadoPor
      createdAt
      dni
      duracion
      empresaId
      empresaId_paisConsecutivoOferta
      estadoAprobacion
      estadoEntrada
      estadoFacturacion
      estadoSalida
      factorMultiplicador
      facturacion
      fechaFin
      fechaInicio
      fecha_pais_consecutivoOferta_trabajadorId
      nombre
      primerApellido
      registroEntradaPor
      registroSalidaPor
      segundoApellido
      tipoTrabajo
      trabajadorId
      unidad
      updatedAt
      valorAFacturar
      valorAPagar
      valorBruto
      valorContribucion
      valorIVA
      valorImposicion
      valorLiquidado
      valorNeto
      valorPresupuestado
      valorUnitario
      __typename
    }
  }
`;
export const getDocumentoEmpresa = /* GraphQL */ `
  query GetDocumentoEmpresa($empresaId: String!) {
    getDocumentoEmpresa(empresaId: $empresaId) {
      createdAt
      empresaId
      llave
      nombre
      updatedAt
      __typename
    }
  }
`;
export const getDocumentoTrabajador = /* GraphQL */ `
  query GetDocumentoTrabajador($tipo: String!, $trabajadorId: String!) {
    getDocumentoTrabajador(tipo: $tipo, trabajadorId: $trabajadorId) {
      createdAt
      fechaVencimiento
      nombre
      tipo
      trabajadorId
      updatedAt
      url
      validadoXEST
      __typename
    }
  }
`;
export const getDocumentosExtras = /* GraphQL */ `
  query GetDocumentosExtras($fecha_uuid: String!, $trabajadorId: String!) {
    getDocumentosExtras(fecha_uuid: $fecha_uuid, trabajadorId: $trabajadorId) {
      createdAt
      fechaFirmaRepresentante
      fechaFirmaTrabajador
      fecha_uuid
      firmadoRepresentanteLegal
      firmadoTrabajador
      ofertaId
      tipoDocumento
      trabajadorId
      updatedAt
      urlDocumento
      __typename
    }
  }
`;
export const getEmpresa = /* GraphQL */ `
  query GetEmpresa($empresaId: ID!) {
    getEmpresa(empresaId: $empresaId) {
      calificacionPromedio
      contadorOfertaTrabajo
      createdAt
      credito
      descripcion
      empresaId
      enlaceLogo
      estId
      fechaCreacion
      giro
      nombre
      saldo
      updatedAt
      __typename
    }
  }
`;
export const getEmpresaEtiqueta = /* GraphQL */ `
  query GetEmpresaEtiqueta($empresaId: String!, $etiquetaId: String!) {
    getEmpresaEtiqueta(empresaId: $empresaId, etiquetaId: $etiquetaId) {
      activa
      color
      colorTexto
      createdAt
      empresaId
      etiquetaId
      nombre
      updatedAt
      __typename
    }
  }
`;
export const getEmpresaEtiquetaTrabajador = /* GraphQL */ `
  query GetEmpresaEtiquetaTrabajador(
    $empresaId: String!
    $etiquetaId_trabajadorId: String!
  ) {
    getEmpresaEtiquetaTrabajador(
      empresaId: $empresaId
      etiquetaId_trabajadorId: $etiquetaId_trabajadorId
    ) {
      createdAt
      empresaId
      empresaId_etiquetaId
      etiquetaId_trabajadorId
      trabajadorId
      updatedAt
      __typename
    }
  }
`;
export const getFacturacion = /* GraphQL */ `
  query GetFacturacion(
    $empresaId: String!
    $pais_consecutivoOferta_fecha: String!
  ) {
    getFacturacion(
      empresaId: $empresaId
      pais_consecutivoOferta_fecha: $pais_consecutivoOferta_fecha
    ) {
      cargo
      createdAt
      empresa
      empresaId
      estadosFacturacion
      facturado
      liquidoFacturado
      liquidoPresupuestado
      mesFacturado
      numeroContable
      pais_consecutivoOferta_fecha
      trabajadores
      ubicacion
      updatedAt
      __typename
    }
  }
`;
export const getFaq = /* GraphQL */ `
  query GetFaq($faqId: ID!) {
    getFaq(faqId: $faqId) {
      categoria
      createdAt
      faqId
      pregunta
      respuesta
      updatedAt
      __typename
    }
  }
`;
export const getFestivos = /* GraphQL */ `
  query GetFestivos($fecha: AWSDateTime!, $pais: String!) {
    getFestivos(fecha: $fecha, pais: $pais) {
      createdAt
      descripcion
      fecha
      irrenuncialbe
      pais
      tipo
      updatedAt
      __typename
    }
  }
`;
export const getGeografia = /* GraphQL */ `
  query GetGeografia($pais: String!, $region_ciudad_comuna: String!) {
    getGeografia(pais: $pais, region_ciudad_comuna: $region_ciudad_comuna) {
      createdAt
      idRegion_idCiudad_idComuna
      pais
      region_ciudad_comuna
      updatedAt
      __typename
    }
  }
`;
export const getHabilidades = /* GraphQL */ `
  query GetHabilidades($id: ID!) {
    getHabilidades(id: $id) {
      createdAt
      descripcion
      estado
      examen
      icono
      id
      nombre
      tipo
      updatedAt
      visibilidad
      __typename
    }
  }
`;
export const getHistorialPagos = /* GraphQL */ `
  query GetHistorialPagos($historialPagoId: String!) {
    getHistorialPagos(historialPagoId: $historialPagoId) {
      createdAt
      fecha
      historialPagoId
      motivo
      tipoTransaccion
      updatedAt
      valor
      __typename
    }
  }
`;
export const getHistoricoTrabajador = /* GraphQL */ `
  query GetHistoricoTrabajador($empresaId: String!, $trabajadorId: String!) {
    getHistoricoTrabajador(empresaId: $empresaId, trabajadorId: $trabajadorId) {
      contadorTrabajos
      createdAt
      duracionUltimoTrabajo
      empresaId
      fechaUltimoTrabajo
      nombreCortoTipoTrabajo
      razonSocialUltimoTrabajo
      trabajadorId
      updatedAt
      __typename
    }
  }
`;
export const getIdentificadorFirmante = /* GraphQL */ `
  query GetIdentificadorFirmante($correo: AWSEmail!) {
    getIdentificadorFirmante(correo: $correo) {
      correo
      createdAt
      identificadorTributario
      updatedAt
      __typename
    }
  }
`;
export const getIdentificadorTributarioEmpresa = /* GraphQL */ `
  query GetIdentificadorTributarioEmpresa(
    $empresaId: String!
    $identificadorTributario: String!
  ) {
    getIdentificadorTributarioEmpresa(
      empresaId: $empresaId
      identificadorTributario: $identificadorTributario
    ) {
      activo
      comuna
      correoRepresentanteLegal
      createdAt
      direccion
      empresaId
      identificadorTributario
      margenContribucion
      nombreFantasia
      nombreRepresentanteLegal
      razonSocial
      rutRepresentanteLegal
      updatedAt
      __typename
    }
  }
`;
export const getLogCambiosTrabajador = /* GraphQL */ `
  query GetLogCambiosTrabajador($correo: AWSEmail!, $tipo: String!) {
    getLogCambiosTrabajador(correo: $correo, tipo: $tipo) {
      cambios
      comentarioBackoffice
      correo
      createdAt
      fecha
      tipo
      updatedAt
      __typename
    }
  }
`;
export const getMultimediaEmpresa = /* GraphQL */ `
  query GetMultimediaEmpresa(
    $correoUsuarioEmpresaId_uuid: String!
    $empresaId: String!
  ) {
    getMultimediaEmpresa(
      correoUsuarioEmpresaId_uuid: $correoUsuarioEmpresaId_uuid
      empresaId: $empresaId
    ) {
      correoUsuarioEmpresaId_uuid
      createdAt
      empresaId
      llave
      tag
      updatedAt
      __typename
    }
  }
`;
export const getNotificacion = /* GraphQL */ `
  query GetNotificacion($destinatarioId: String!, $fecha: AWSDateTime!) {
    getNotificacion(destinatarioId: $destinatarioId, fecha: $fecha) {
      asunto
      createdAt
      destinatarioId
      fecha
      id
      leida
      mensaje
      mensajeHtml
      payload
      remitenteId
      tipoNotificacion
      updatedAt
      urlDestino
      __typename
    }
  }
`;
export const getOfertaActiva = /* GraphQL */ `
  query GetOfertaActiva($empresaId: String!, $pais_consecutivoOferta: String!) {
    getOfertaActiva(
      empresaId: $empresaId
      pais_consecutivoOferta: $pais_consecutivoOferta
    ) {
      createdAt
      empresaId
      pais_consecutivoOferta
      updatedAt
      __typename
    }
  }
`;
export const getOfertaTrabajo = /* GraphQL */ `
  query GetOfertaTrabajo(
    $empresaId: String!
    $pais_consecutivoOferta: String!
  ) {
    getOfertaTrabajo(
      empresaId: $empresaId
      pais_consecutivoOferta: $pais_consecutivoOferta
    ) {
      brutoTotal
      causalContrado
      colacion
      costoNeto
      costoServicio
      createdAt
      descripcionTipoTrabajo
      empresaId
      estadoActual
      facturadoRealFinal
      fechaCaducidad
      fechaFin
      firmaContrato
      historialEstados
      idOferta
      identificadorTributario
      infoOnboarding
      isPublic
      liquidoTotal
      multimediaOfertaId
      nombreContrato
      nombreReemplazado
      nuevosPostulantes
      pais_consecutivoOferta
      provisionFondos
      razonSocial
      rubro
      rutReemplazado
      tipo
      tipoTrabajo
      totalHoras
      totalVacantes
      transporte
      turnos
      ubicacion
      updatedAt
      usuariosInvitados
      valorGratificacion
      __typename
    }
  }
`;
export const getOfertaTrabajoHabilidades = /* GraphQL */ `
  query GetOfertaTrabajoHabilidades(
    $empresaId_pais_consecutivoOferta: String!
    $habilidadId: String!
  ) {
    getOfertaTrabajoHabilidades(
      empresaId_pais_consecutivoOferta: $empresaId_pais_consecutivoOferta
      habilidadId: $habilidadId
    ) {
      createdAt
      empresaId_pais_consecutivoOferta
      habilidadId
      obligatoria
      updatedAt
      __typename
    }
  }
`;
export const getPorcentajeImposicionesPais = /* GraphQL */ `
  query GetPorcentajeImposicionesPais($pais: String!) {
    getPorcentajeImposicionesPais(pais: $pais) {
      createdAt
      iva
      pais
      porcentaje
      updatedAt
      valorMinimoLegal
      __typename
    }
  }
`;
export const getPreferenciasNotificaciones = /* GraphQL */ `
  query GetPreferenciasNotificaciones(
    $tipoTrabajo_ubicacion: String!
    $trabajadorId: String!
  ) {
    getPreferenciasNotificaciones(
      tipoTrabajo_ubicacion: $tipoTrabajo_ubicacion
      trabajadorId: $trabajadorId
    ) {
      createdAt
      tipoTrabajo
      tipoTrabajo_ubicacion
      trabajadorId
      ubicacion
      updatedAt
      __typename
    }
  }
`;
export const getRegistroIncidentes = /* GraphQL */ `
  query GetRegistroIncidentes($fecha: String!, $pais: String!) {
    getRegistroIncidentes(fecha: $fecha, pais: $pais) {
      coordenadas
      createdAt
      descripcion
      fecha
      fechaMarcaje
      fechaServidor
      pais
      posicionCorrecta
      tipo
      trabajadorId
      updatedAt
      __typename
    }
  }
`;
export const getReplicaTalana = /* GraphQL */ `
  query GetReplicaTalana($talanaId: Int!, $tipoReplica: String!) {
    getReplicaTalana(talanaId: $talanaId, tipoReplica: $tipoReplica) {
      codigo
      creacion
      createdAt
      nombre
      pais
      razonSocial
      rut
      talanaId
      tipo
      tipoReplica
      updatedAt
      vigente
      __typename
    }
  }
`;
export const getReporteBackoffice = /* GraphQL */ `
  query GetReporteBackoffice(
    $empresaId: String!
    $pais_consecutivoOferta_trabajadorId: String!
  ) {
    getReporteBackoffice(
      empresaId: $empresaId
      pais_consecutivoOferta_trabajadorId: $pais_consecutivoOferta_trabajadorId
    ) {
      calleTrabajador
      calleUsuaria
      cargo
      comunaTrabajador
      comunaUsuaria
      contratoId
      createdAt
      deptoTrabajador
      detalleTurnos
      empresaId
      estadoActual
      estadoContrato
      estadoContratoAnpd
      fechaContrato
      liquidoPago
      montoImponible
      montoNoImponible
      nacionalidad
      nombreContrato
      nroCalleTrabajador
      nroUsuaria
      pais_consecutivoOferta_trabajadorId
      regionTrabajador
      regionUsuaria
      rutTrabajador
      rutUsuaria
      sueldoBase
      telefonoTrabajador
      totalHoras
      trabajadorId
      updatedAt
      __typename
    }
  }
`;
export const getRequisito = /* GraphQL */ `
  query GetRequisito(
    $empresaId: String!
    $pais_consecutivoOferta_uuid: String!
  ) {
    getRequisito(
      empresaId: $empresaId
      pais_consecutivoOferta_uuid: $pais_consecutivoOferta_uuid
    ) {
      createdAt
      descripcion
      empresaId
      fechaVencimiento
      pais_consecutivoOferta_uuid
      requiereArchivo
      updatedAt
      __typename
    }
  }
`;
export const getRequisitosLegales = /* GraphQL */ `
  query GetRequisitosLegales($pais: String!) {
    getRequisitosLegales(pais: $pais) {
      createdAt
      horasMaximasXSemana
      pais
      porcentajeBase
      porcentajeHoraExtra
      porcentajeParafiscales
      porcentajeSemanaCorrida
      updatedAt
      __typename
    }
  }
`;
export const getRubroTipoTrabajo = /* GraphQL */ `
  query GetRubroTipoTrabajo($pais: String!, $rubro_tipoTrabajo: String!) {
    getRubroTipoTrabajo(pais: $pais, rubro_tipoTrabajo: $rubro_tipoTrabajo) {
      createdAt
      descripcionRubro
      descripcionTipoTrabajo
      duracionMaximaTurno
      duracionMaximaTurnoParaColacion
      duracionMaximaTurnoXSemana
      habilidades
      horasMaximasXDia
      horasMaximasXMes
      horasMaximasXSemana
      nombreOficial
      pais
      porcentajeCostoFestivo
      rubro_tipoTrabajo
      tiempoColacion
      updatedAt
      valorMaxRecomendado
      valorMinRecomendado
      __typename
    }
  }
`;
export const getSeguridadSocial = /* GraphQL */ `
  query GetSeguridadSocial($tipo: String!, $trabajadorId: String!) {
    getSeguridadSocial(tipo: $tipo, trabajadorId: $trabajadorId) {
      createdAt
      nombre
      talanaId
      tipo
      trabajadorId
      updatedAt
      __typename
    }
  }
`;
export const getTemplateNotificacion = /* GraphQL */ `
  query GetTemplateNotificacion($app: String!, $nombre: String!) {
    getTemplateNotificacion(app: $app, nombre: $nombre) {
      app
      createdAt
      mensajeHtml
      nombre
      updatedAt
      variables
      __typename
    }
  }
`;
export const getTipoUsuario = /* GraphQL */ `
  query GetTipoUsuario($idTipoUsuario: ID!) {
    getTipoUsuario(idTipoUsuario: $idTipoUsuario) {
      createdAt
      dotacionDiaria
      firmaPendiente
      gestionAsistencias
      idTipoUsuario
      menuSolicitudes
      multimediaEmpresa
      nombre
      nuevaSolicitud
      panelDeControl
      perfilEmpresa
      principal
      provisionPendiente
      recargar
      rutsAsociados
      solicitudes
      trabajosEnCurso
      transacciones
      ubicaciones
      updatedAt
      usuarios
      verTodasSolicitudes
      __typename
    }
  }
`;
export const getTrabajador = /* GraphQL */ `
  query GetTrabajador($correo: AWSEmail!) {
    getTrabajador(correo: $correo) {
      activo
      banco
      calificacionPromedio
      calle
      canalesNotificaciones
      ciudad
      clave
      comuna
      correo
      createdAt
      depto
      descripcion
      direccion
      dni
      enlaceFoto
      estId
      fechaNacimiento
      firebaseToken
      idBanco
      nacionalidad
      noCuentaBancaria
      nombre
      numero
      origen
      pais
      primerApellido
      region
      segundaClave
      segundoApellido
      sexo
      telefono
      tipoCuenta
      ultimaFechaConsultaAnuncios
      updatedAt
      uuid
      validadoXEST
      validarDocumentos
      visibilidadFoto
      __typename
    }
  }
`;
export const getTrabajadorCalendario = /* GraphQL */ `
  query GetTrabajadorCalendario(
    $fecha_empresaId_pais_consecutivoOferta: String!
    $trabajadorId: String!
  ) {
    getTrabajadorCalendario(
      fecha_empresaId_pais_consecutivoOferta: $fecha_empresaId_pais_consecutivoOferta
      trabajadorId: $trabajadorId
    ) {
      aprobado
      cargoId
      confirmado
      createdAt
      detalleModificacionTurno
      duracion
      empresaId
      entrada
      estadoAprobacion
      estadoEntrada
      estadoSalida
      fechaFin
      fecha_empresaId_pais_consecutivoOferta
      llegada
      pais_consecutivoOferta
      primerDiaContrato
      salida
      timeZone
      trabajadorId
      turno
      ubicacionId
      ultimoDia
      ultimoDiaContrato
      unidad
      updatedAt
      valorUnitario
      __typename
    }
  }
`;
export const getTrabajadorHabilidades = /* GraphQL */ `
  query GetTrabajadorHabilidades($correo: AWSEmail!, $habilidadId: String!) {
    getTrabajadorHabilidades(correo: $correo, habilidadId: $habilidadId) {
      certificado
      correo
      createdAt
      estado
      fechaSolicitud
      habilidadId
      historialEstados
      infoAdicionalCertificado
      resultadoExamen
      tipoHabilidad
      updatedAt
      __typename
    }
  }
`;
export const getTrabajadorOferta = /* GraphQL */ `
  query GetTrabajadorOferta(
    $empresaId: String!
    $pais_consecutivoOferta_trabajadorId: String!
  ) {
    getTrabajadorOferta(
      empresaId: $empresaId
      pais_consecutivoOferta_trabajadorId: $pais_consecutivoOferta_trabajadorId
    ) {
      cartaAviso
      contratoEmpresa
      contratoId
      createdAt
      cumplimientoRequisito
      dtIndex
      empresaId
      empresaId_pais_consecutivoOferta
      estadoActual
      estadoContrato
      estadoContratoAnpd
      fechaContrato
      hashRepLegal
      hashTrabajador
      historialEstados
      historialEstadosContrato
      historialEstadosContratoAnpd
      infoOnboardingLeida
      origenPostulacion
      pais_consecutivoOferta_trabajadorId
      pathContratos
      pathContratosCliente
      trabajadorId
      turnos
      turnosExtra
      updatedAt
      valorAPagar
      __typename
    }
  }
`;
export const getTrabajadorPago = /* GraphQL */ `
  query GetTrabajadorPago($fecha_uuid: AWSDate!, $trabajadorId: String!) {
    getTrabajadorPago(fecha_uuid: $fecha_uuid, trabajadorId: $trabajadorId) {
      concepto
      createdAt
      empresaId_pais_consecutivoOferta
      fecha_uuid
      historialPagoId
      trabajadorId
      updatedAt
      valor
      __typename
    }
  }
`;
export const getTrabajoFavorito = /* GraphQL */ `
  query GetTrabajoFavorito($trabajadorId: String!) {
    getTrabajoFavorito(trabajadorId: $trabajadorId) {
      createdAt
      ofertasTrabajo
      trabajadorId
      updatedAt
      __typename
    }
  }
`;
export const getTransaccion = /* GraphQL */ `
  query GetTransaccion($empresaId: String!, $fecha_uuid: String!) {
    getTransaccion(empresaId: $empresaId, fecha_uuid: $fecha_uuid) {
      correo
      createdAt
      detalle
      empresaId
      fecha_uuid
      monto
      observacion
      tipo
      updatedAt
      __typename
    }
  }
`;
export const getUbicacion = /* GraphQL */ `
  query GetUbicacion(
    $empresaId: String!
    $pais_region_ciudad_comuna_uuid: String!
  ) {
    getUbicacion(
      empresaId: $empresaId
      pais_region_ciudad_comuna_uuid: $pais_region_ciudad_comuna_uuid
    ) {
      activa
      codigoPostal
      createdAt
      direccion
      empresaId
      nombre
      pais_region_ciudad_comuna_uuid
      timezone
      ubicacion
      updatedAt
      __typename
    }
  }
`;
export const getUbicacionSupervisor = /* GraphQL */ `
  query GetUbicacionSupervisor(
    $correo: AWSEmail!
    $pais_region_ciudad_comuna_uuid: String!
  ) {
    getUbicacionSupervisor(
      correo: $correo
      pais_region_ciudad_comuna_uuid: $pais_region_ciudad_comuna_uuid
    ) {
      correo
      createdAt
      pais_region_ciudad_comuna_uuid
      updatedAt
      __typename
    }
  }
`;
export const getUsuarioBackoffice = /* GraphQL */ `
  query GetUsuarioBackoffice($correo: AWSEmail!) {
    getUsuarioBackoffice(correo: $correo) {
      activo
      cargo
      correo
      createdAt
      dni
      nombre
      telefono
      tipoUsuario
      updatedAt
      __typename
    }
  }
`;
export const getUsuarioEmpresa = /* GraphQL */ `
  query GetUsuarioEmpresa($correo: AWSEmail!, $empresaId: String!) {
    getUsuarioEmpresa(correo: $correo, empresaId: $empresaId) {
      activo
      cargo
      clave
      correo
      createdAt
      dni
      empresaId
      nombre
      telefono
      tipoUsuario
      updatedAt
      __typename
    }
  }
`;
export const listBackgrounds = /* GraphQL */ `
  query ListBackgrounds(
    $filter: ModelBackgroundFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $tipo_uuid: ModelStringKeyConditionInput
    $trabajadorId: String
  ) {
    listBackgrounds(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      tipo_uuid: $tipo_uuid
      trabajadorId: $trabajadorId
    ) {
      items {
        anoInicio
        cargoTitulo
        createdAt
        descripcion
        duracionMeses
        institucion
        tipo_uuid
        trabajadorId
        updatedAt
        validadoXEST
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCalificacions = /* GraphQL */ `
  query ListCalificacions(
    $empresaId: String
    $filter: ModelCalificacionFilterInput
    $limit: Int
    $nextToken: String
    $pais_consecutivoOferta_trabajadorId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listCalificacions(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_consecutivoOferta_trabajadorId: $pais_consecutivoOferta_trabajadorId
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        detalles
        empresaId
        fecha
        pais_consecutivoOferta_trabajadorId
        tipo
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listComentariosCambiosTrabajadors = /* GraphQL */ `
  query ListComentariosCambiosTrabajadors(
    $fecha: ModelStringKeyConditionInput
    $filter: ModelComentariosCambiosTrabajadorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $trabajadorId: String
  ) {
    listComentariosCambiosTrabajadors(
      fecha: $fecha
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      trabajadorId: $trabajadorId
    ) {
      items {
        comentario
        createdAt
        fecha
        trabajadorId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listComentariosOfertaTrabajos = /* GraphQL */ `
  query ListComentariosOfertaTrabajos(
    $empresaId: String
    $filter: ModelComentariosOfertaTrabajoFilterInput
    $limit: Int
    $nextToken: String
    $pais_consecutivoOferta_fecha: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listComentariosOfertaTrabajos(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_consecutivoOferta_fecha: $pais_consecutivoOferta_fecha
      sortDirection: $sortDirection
    ) {
      items {
        comentario
        createdAt
        empresaId
        pais_consecutivoOferta_fecha
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listComunaTipoTrabajoRecomendaciones = /* GraphQL */ `
  query ListComunaTipoTrabajoRecomendaciones(
    $filter: ModelComunaTipoTrabajoRecomendacionesFilterInput
    $limit: Int
    $nextToken: String
    $pais: String
    $region_ciudad_comuna_rubro_tipoTrabajo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listComunaTipoTrabajoRecomendaciones(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais: $pais
      region_ciudad_comuna_rubro_tipoTrabajo: $region_ciudad_comuna_rubro_tipoTrabajo
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        pais
        region_ciudad_comuna_rubro_tipoTrabajo
        rubro_tipoTrabajo
        updatedAt
        valorMaxRecomendado
        valorMinLegal
        valorMinRecomendado
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listConfiguracionEmpresas = /* GraphQL */ `
  query ListConfiguracionEmpresas(
    $empresaId: ID
    $filter: ModelConfiguracionEmpresaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listConfiguracionEmpresas(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        cargos
        contratos
        createdAt
        empresaId
        postulacion
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listContadors = /* GraphQL */ `
  query ListContadors(
    $empresaId: String
    $filter: ModelContadorFilterInput
    $limit: Int
    $nextToken: String
    $pais_consecutivoOferta: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listContadors(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_consecutivoOferta: $pais_consecutivoOferta
      sortDirection: $sortDirection
    ) {
      items {
        aceptadoXEmpresa
        aceptadoXTrabajador
        aceptadosTurno
        contratoAnuladoXBackoffice
        contratoAnuladoXEmpresa
        contratoAnuladoXTrabajador
        contratoCerrado
        createdAt
        descartadoXEmpresa
        desistidaXTrabajador
        ejecutando
        empresaId
        pais_consecutivoOferta
        postulado
        provisionadoXEmpresa
        rechazadoXEmpresa
        rechazadoXTrabajador
        seleccionadoXEmpresa
        seleccionadosTurno
        terminado
        updatedAt
        validado
        visitasUsuarioAutenticado
        visitasUsuarioNoAutenticado
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listContratoPendientes = /* GraphQL */ `
  query ListContratoPendientes(
    $empresaId: String
    $filter: ModelContratoPendienteFilterInput
    $limit: Int
    $nextToken: String
    $pais_consecutivoOferta_uuid: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listContratoPendientes(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_consecutivoOferta_uuid: $pais_consecutivoOferta_uuid
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        empresaId
        pais_consecutivoOferta_uuid
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listContratoes = /* GraphQL */ `
  query ListContratoes(
    $empresaId: String
    $filter: ModelContratoFilterInput
    $limit: Int
    $nextToken: String
    $pais_consecutivoOferta_uuid: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listContratoes(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_consecutivoOferta_uuid: $pais_consecutivoOferta_uuid
      sortDirection: $sortDirection
    ) {
      items {
        cantidadPersonasAContratar
        createdAt
        empresaId
        estadoActual
        historialEstados
        pais_consecutivoOferta_uuid
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCredenciales = /* GraphQL */ `
  query ListCredenciales(
    $apiKey: ID
    $filter: ModelCredencialesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCredenciales(
      apiKey: $apiKey
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        activa
        apiKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDetalleFacturacions = /* GraphQL */ `
  query ListDetalleFacturacions(
    $empresaId: String
    $fecha_pais_consecutivoOferta_trabajadorId: ModelStringKeyConditionInput
    $filter: ModelDetalleFacturacionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDetalleFacturacions(
      empresaId: $empresaId
      fecha_pais_consecutivoOferta_trabajadorId: $fecha_pais_consecutivoOferta_trabajadorId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        aprobadoPor
        createdAt
        dni
        duracion
        empresaId
        empresaId_paisConsecutivoOferta
        estadoAprobacion
        estadoEntrada
        estadoFacturacion
        estadoSalida
        factorMultiplicador
        facturacion
        fechaFin
        fechaInicio
        fecha_pais_consecutivoOferta_trabajadorId
        nombre
        primerApellido
        registroEntradaPor
        registroSalidaPor
        segundoApellido
        tipoTrabajo
        trabajadorId
        unidad
        updatedAt
        valorAFacturar
        valorAPagar
        valorBruto
        valorContribucion
        valorIVA
        valorImposicion
        valorLiquidado
        valorNeto
        valorPresupuestado
        valorUnitario
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDocumentoEmpresas = /* GraphQL */ `
  query ListDocumentoEmpresas(
    $empresaId: String
    $filter: ModelDocumentoEmpresaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDocumentoEmpresas(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        empresaId
        llave
        nombre
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDocumentoTrabajadors = /* GraphQL */ `
  query ListDocumentoTrabajadors(
    $filter: ModelDocumentoTrabajadorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $tipo: ModelStringKeyConditionInput
    $trabajadorId: String
  ) {
    listDocumentoTrabajadors(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      tipo: $tipo
      trabajadorId: $trabajadorId
    ) {
      items {
        createdAt
        fechaVencimiento
        nombre
        tipo
        trabajadorId
        updatedAt
        url
        validadoXEST
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDocumentosExtras = /* GraphQL */ `
  query ListDocumentosExtras(
    $fecha_uuid: ModelStringKeyConditionInput
    $filter: ModelDocumentosExtrasFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $trabajadorId: String
  ) {
    listDocumentosExtras(
      fecha_uuid: $fecha_uuid
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      trabajadorId: $trabajadorId
    ) {
      items {
        createdAt
        fechaFirmaRepresentante
        fechaFirmaTrabajador
        fecha_uuid
        firmadoRepresentanteLegal
        firmadoTrabajador
        ofertaId
        tipoDocumento
        trabajadorId
        updatedAt
        urlDocumento
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listEmpresaEtiquetaTrabajadors = /* GraphQL */ `
  query ListEmpresaEtiquetaTrabajadors(
    $empresaId: String
    $etiquetaId_trabajadorId: ModelStringKeyConditionInput
    $filter: ModelEmpresaEtiquetaTrabajadorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listEmpresaEtiquetaTrabajadors(
      empresaId: $empresaId
      etiquetaId_trabajadorId: $etiquetaId_trabajadorId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        empresaId
        empresaId_etiquetaId
        etiquetaId_trabajadorId
        trabajadorId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listEmpresaEtiquetas = /* GraphQL */ `
  query ListEmpresaEtiquetas(
    $empresaId: String
    $etiquetaId: ModelStringKeyConditionInput
    $filter: ModelEmpresaEtiquetaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listEmpresaEtiquetas(
      empresaId: $empresaId
      etiquetaId: $etiquetaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        activa
        color
        colorTexto
        createdAt
        empresaId
        etiquetaId
        nombre
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listEmpresas = /* GraphQL */ `
  query ListEmpresas(
    $empresaId: ID
    $filter: ModelEmpresaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listEmpresas(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        calificacionPromedio
        contadorOfertaTrabajo
        createdAt
        credito
        descripcion
        empresaId
        enlaceLogo
        estId
        fechaCreacion
        giro
        nombre
        saldo
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listFacturacions = /* GraphQL */ `
  query ListFacturacions(
    $empresaId: String
    $filter: ModelFacturacionFilterInput
    $limit: Int
    $nextToken: String
    $pais_consecutivoOferta_fecha: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listFacturacions(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_consecutivoOferta_fecha: $pais_consecutivoOferta_fecha
      sortDirection: $sortDirection
    ) {
      items {
        cargo
        createdAt
        empresa
        empresaId
        estadosFacturacion
        facturado
        liquidoFacturado
        liquidoPresupuestado
        mesFacturado
        numeroContable
        pais_consecutivoOferta_fecha
        trabajadores
        ubicacion
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listFaqs = /* GraphQL */ `
  query ListFaqs(
    $faqId: ID
    $filter: ModelFaqFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFaqs(
      faqId: $faqId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        categoria
        createdAt
        faqId
        pregunta
        respuesta
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listFestivos = /* GraphQL */ `
  query ListFestivos(
    $fecha: ModelStringKeyConditionInput
    $filter: ModelFestivosFilterInput
    $limit: Int
    $nextToken: String
    $pais: String
    $sortDirection: ModelSortDirection
  ) {
    listFestivos(
      fecha: $fecha
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais: $pais
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        descripcion
        fecha
        irrenuncialbe
        pais
        tipo
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listGeografias = /* GraphQL */ `
  query ListGeografias(
    $filter: ModelGeografiaFilterInput
    $limit: Int
    $nextToken: String
    $pais: String
    $region_ciudad_comuna: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listGeografias(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais: $pais
      region_ciudad_comuna: $region_ciudad_comuna
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        idRegion_idCiudad_idComuna
        pais
        region_ciudad_comuna
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listHabilidades = /* GraphQL */ `
  query ListHabilidades(
    $filter: ModelHabilidadesFilterInput
    $id: ID
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listHabilidades(
      filter: $filter
      id: $id
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        descripcion
        estado
        examen
        icono
        id
        nombre
        tipo
        updatedAt
        visibilidad
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listHistorialPagos = /* GraphQL */ `
  query ListHistorialPagos(
    $filter: ModelHistorialPagosFilterInput
    $historialPagoId: String
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listHistorialPagos(
      filter: $filter
      historialPagoId: $historialPagoId
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        fecha
        historialPagoId
        motivo
        tipoTransaccion
        updatedAt
        valor
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listHistoricoTrabajadors = /* GraphQL */ `
  query ListHistoricoTrabajadors(
    $empresaId: String
    $filter: ModelHistoricoTrabajadorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $trabajadorId: ModelStringKeyConditionInput
  ) {
    listHistoricoTrabajadors(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      trabajadorId: $trabajadorId
    ) {
      items {
        contadorTrabajos
        createdAt
        duracionUltimoTrabajo
        empresaId
        fechaUltimoTrabajo
        nombreCortoTipoTrabajo
        razonSocialUltimoTrabajo
        trabajadorId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listIdentificadorFirmantes = /* GraphQL */ `
  query ListIdentificadorFirmantes(
    $correo: AWSEmail
    $filter: ModelIdentificadorFirmanteFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listIdentificadorFirmantes(
      correo: $correo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        correo
        createdAt
        identificadorTributario
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listIdentificadorTributarioEmpresas = /* GraphQL */ `
  query ListIdentificadorTributarioEmpresas(
    $empresaId: String
    $filter: ModelIdentificadorTributarioEmpresaFilterInput
    $identificadorTributario: ModelStringKeyConditionInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listIdentificadorTributarioEmpresas(
      empresaId: $empresaId
      filter: $filter
      identificadorTributario: $identificadorTributario
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        activo
        comuna
        correoRepresentanteLegal
        createdAt
        direccion
        empresaId
        identificadorTributario
        margenContribucion
        nombreFantasia
        nombreRepresentanteLegal
        razonSocial
        rutRepresentanteLegal
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listLogCambiosTrabajadors = /* GraphQL */ `
  query ListLogCambiosTrabajadors(
    $correo: AWSEmail
    $filter: ModelLogCambiosTrabajadorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $tipo: ModelStringKeyConditionInput
  ) {
    listLogCambiosTrabajadors(
      correo: $correo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      tipo: $tipo
    ) {
      items {
        cambios
        comentarioBackoffice
        correo
        createdAt
        fecha
        tipo
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMultimediaEmpresas = /* GraphQL */ `
  query ListMultimediaEmpresas(
    $correoUsuarioEmpresaId_uuid: ModelStringKeyConditionInput
    $empresaId: String
    $filter: ModelMultimediaEmpresaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMultimediaEmpresas(
      correoUsuarioEmpresaId_uuid: $correoUsuarioEmpresaId_uuid
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        correoUsuarioEmpresaId_uuid
        createdAt
        empresaId
        llave
        tag
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listNotificacions = /* GraphQL */ `
  query ListNotificacions(
    $destinatarioId: String
    $fecha: ModelStringKeyConditionInput
    $filter: ModelNotificacionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listNotificacions(
      destinatarioId: $destinatarioId
      fecha: $fecha
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        asunto
        createdAt
        destinatarioId
        fecha
        id
        leida
        mensaje
        mensajeHtml
        payload
        remitenteId
        tipoNotificacion
        updatedAt
        urlDestino
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOfertaActivas = /* GraphQL */ `
  query ListOfertaActivas(
    $empresaId: String
    $filter: ModelOfertaActivaFilterInput
    $limit: Int
    $nextToken: String
    $pais_consecutivoOferta: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listOfertaActivas(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_consecutivoOferta: $pais_consecutivoOferta
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        empresaId
        pais_consecutivoOferta
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOfertaTrabajoHabilidades = /* GraphQL */ `
  query ListOfertaTrabajoHabilidades(
    $empresaId_pais_consecutivoOferta: String
    $filter: ModelOfertaTrabajoHabilidadesFilterInput
    $habilidadId: ModelStringKeyConditionInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOfertaTrabajoHabilidades(
      empresaId_pais_consecutivoOferta: $empresaId_pais_consecutivoOferta
      filter: $filter
      habilidadId: $habilidadId
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        empresaId_pais_consecutivoOferta
        habilidadId
        obligatoria
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOfertaTrabajos = /* GraphQL */ `
  query ListOfertaTrabajos(
    $empresaId: String
    $filter: ModelOfertaTrabajoFilterInput
    $limit: Int
    $nextToken: String
    $pais_consecutivoOferta: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listOfertaTrabajos(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_consecutivoOferta: $pais_consecutivoOferta
      sortDirection: $sortDirection
    ) {
      items {
        brutoTotal
        causalContrado
        colacion
        costoNeto
        costoServicio
        createdAt
        descripcionTipoTrabajo
        empresaId
        estadoActual
        facturadoRealFinal
        fechaCaducidad
        fechaFin
        firmaContrato
        historialEstados
        idOferta
        identificadorTributario
        infoOnboarding
        isPublic
        liquidoTotal
        multimediaOfertaId
        nombreContrato
        nombreReemplazado
        nuevosPostulantes
        pais_consecutivoOferta
        provisionFondos
        razonSocial
        rubro
        rutReemplazado
        tipo
        tipoTrabajo
        totalHoras
        totalVacantes
        transporte
        turnos
        ubicacion
        updatedAt
        usuariosInvitados
        valorGratificacion
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPorcentajeImposicionesPais = /* GraphQL */ `
  query ListPorcentajeImposicionesPais(
    $filter: ModelPorcentajeImposicionesPaisFilterInput
    $limit: Int
    $nextToken: String
    $pais: String
    $sortDirection: ModelSortDirection
  ) {
    listPorcentajeImposicionesPais(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais: $pais
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        iva
        pais
        porcentaje
        updatedAt
        valorMinimoLegal
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPreferenciasNotificaciones = /* GraphQL */ `
  query ListPreferenciasNotificaciones(
    $filter: ModelPreferenciasNotificacionesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $tipoTrabajo_ubicacion: ModelStringKeyConditionInput
    $trabajadorId: String
  ) {
    listPreferenciasNotificaciones(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      tipoTrabajo_ubicacion: $tipoTrabajo_ubicacion
      trabajadorId: $trabajadorId
    ) {
      items {
        createdAt
        tipoTrabajo
        tipoTrabajo_ubicacion
        trabajadorId
        ubicacion
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRegistroIncidentes = /* GraphQL */ `
  query ListRegistroIncidentes(
    $fecha: ModelStringKeyConditionInput
    $filter: ModelRegistroIncidentesFilterInput
    $limit: Int
    $nextToken: String
    $pais: String
    $sortDirection: ModelSortDirection
  ) {
    listRegistroIncidentes(
      fecha: $fecha
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais: $pais
      sortDirection: $sortDirection
    ) {
      items {
        coordenadas
        createdAt
        descripcion
        fecha
        fechaMarcaje
        fechaServidor
        pais
        posicionCorrecta
        tipo
        trabajadorId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listReplicaTalanas = /* GraphQL */ `
  query ListReplicaTalanas(
    $filter: ModelReplicaTalanaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $talanaId: ModelIntKeyConditionInput
    $tipoReplica: String
  ) {
    listReplicaTalanas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      talanaId: $talanaId
      tipoReplica: $tipoReplica
    ) {
      items {
        codigo
        creacion
        createdAt
        nombre
        pais
        razonSocial
        rut
        talanaId
        tipo
        tipoReplica
        updatedAt
        vigente
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listReporteBackoffices = /* GraphQL */ `
  query ListReporteBackoffices(
    $empresaId: String
    $filter: ModelReporteBackofficeFilterInput
    $limit: Int
    $nextToken: String
    $pais_consecutivoOferta_trabajadorId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listReporteBackoffices(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_consecutivoOferta_trabajadorId: $pais_consecutivoOferta_trabajadorId
      sortDirection: $sortDirection
    ) {
      items {
        calleTrabajador
        calleUsuaria
        cargo
        comunaTrabajador
        comunaUsuaria
        contratoId
        createdAt
        deptoTrabajador
        detalleTurnos
        empresaId
        estadoActual
        estadoContrato
        estadoContratoAnpd
        fechaContrato
        liquidoPago
        montoImponible
        montoNoImponible
        nacionalidad
        nombreContrato
        nroCalleTrabajador
        nroUsuaria
        pais_consecutivoOferta_trabajadorId
        regionTrabajador
        regionUsuaria
        rutTrabajador
        rutUsuaria
        sueldoBase
        telefonoTrabajador
        totalHoras
        trabajadorId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRequisitos = /* GraphQL */ `
  query ListRequisitos(
    $empresaId: String
    $filter: ModelRequisitoFilterInput
    $limit: Int
    $nextToken: String
    $pais_consecutivoOferta_uuid: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listRequisitos(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_consecutivoOferta_uuid: $pais_consecutivoOferta_uuid
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        descripcion
        empresaId
        fechaVencimiento
        pais_consecutivoOferta_uuid
        requiereArchivo
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRequisitosLegales = /* GraphQL */ `
  query ListRequisitosLegales(
    $filter: ModelRequisitosLegalesFilterInput
    $limit: Int
    $nextToken: String
    $pais: String
    $sortDirection: ModelSortDirection
  ) {
    listRequisitosLegales(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais: $pais
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        horasMaximasXSemana
        pais
        porcentajeBase
        porcentajeHoraExtra
        porcentajeParafiscales
        porcentajeSemanaCorrida
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRubroTipoTrabajos = /* GraphQL */ `
  query ListRubroTipoTrabajos(
    $filter: ModelRubroTipoTrabajoFilterInput
    $limit: Int
    $nextToken: String
    $pais: String
    $rubro_tipoTrabajo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listRubroTipoTrabajos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais: $pais
      rubro_tipoTrabajo: $rubro_tipoTrabajo
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        descripcionRubro
        descripcionTipoTrabajo
        duracionMaximaTurno
        duracionMaximaTurnoParaColacion
        duracionMaximaTurnoXSemana
        habilidades
        horasMaximasXDia
        horasMaximasXMes
        horasMaximasXSemana
        nombreOficial
        pais
        porcentajeCostoFestivo
        rubro_tipoTrabajo
        tiempoColacion
        updatedAt
        valorMaxRecomendado
        valorMinRecomendado
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSeguridadSocials = /* GraphQL */ `
  query ListSeguridadSocials(
    $filter: ModelSeguridadSocialFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $tipo: ModelStringKeyConditionInput
    $trabajadorId: String
  ) {
    listSeguridadSocials(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      tipo: $tipo
      trabajadorId: $trabajadorId
    ) {
      items {
        createdAt
        nombre
        talanaId
        tipo
        trabajadorId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTemplateNotificacions = /* GraphQL */ `
  query ListTemplateNotificacions(
    $app: String
    $filter: ModelTemplateNotificacionFilterInput
    $limit: Int
    $nextToken: String
    $nombre: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listTemplateNotificacions(
      app: $app
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      nombre: $nombre
      sortDirection: $sortDirection
    ) {
      items {
        app
        createdAt
        mensajeHtml
        nombre
        updatedAt
        variables
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTipoUsuarios = /* GraphQL */ `
  query ListTipoUsuarios(
    $filter: ModelTipoUsuarioFilterInput
    $idTipoUsuario: ID
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTipoUsuarios(
      filter: $filter
      idTipoUsuario: $idTipoUsuario
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        dotacionDiaria
        firmaPendiente
        gestionAsistencias
        idTipoUsuario
        menuSolicitudes
        multimediaEmpresa
        nombre
        nuevaSolicitud
        panelDeControl
        perfilEmpresa
        principal
        provisionPendiente
        recargar
        rutsAsociados
        solicitudes
        trabajosEnCurso
        transacciones
        ubicaciones
        updatedAt
        usuarios
        verTodasSolicitudes
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTrabajadorCalendarios = /* GraphQL */ `
  query ListTrabajadorCalendarios(
    $fecha_empresaId_pais_consecutivoOferta: ModelStringKeyConditionInput
    $filter: ModelTrabajadorCalendarioFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $trabajadorId: String
  ) {
    listTrabajadorCalendarios(
      fecha_empresaId_pais_consecutivoOferta: $fecha_empresaId_pais_consecutivoOferta
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      trabajadorId: $trabajadorId
    ) {
      items {
        aprobado
        cargoId
        confirmado
        createdAt
        detalleModificacionTurno
        duracion
        empresaId
        entrada
        estadoAprobacion
        estadoEntrada
        estadoSalida
        fechaFin
        fecha_empresaId_pais_consecutivoOferta
        llegada
        pais_consecutivoOferta
        primerDiaContrato
        salida
        timeZone
        trabajadorId
        turno
        ubicacionId
        ultimoDia
        ultimoDiaContrato
        unidad
        updatedAt
        valorUnitario
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTrabajadorHabilidades = /* GraphQL */ `
  query ListTrabajadorHabilidades(
    $correo: AWSEmail
    $filter: ModelTrabajadorHabilidadesFilterInput
    $habilidadId: ModelStringKeyConditionInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTrabajadorHabilidades(
      correo: $correo
      filter: $filter
      habilidadId: $habilidadId
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        certificado
        correo
        createdAt
        estado
        fechaSolicitud
        habilidadId
        historialEstados
        infoAdicionalCertificado
        resultadoExamen
        tipoHabilidad
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTrabajadorOfertas = /* GraphQL */ `
  query ListTrabajadorOfertas(
    $empresaId: String
    $filter: ModelTrabajadorOfertaFilterInput
    $limit: Int
    $nextToken: String
    $pais_consecutivoOferta_trabajadorId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listTrabajadorOfertas(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_consecutivoOferta_trabajadorId: $pais_consecutivoOferta_trabajadorId
      sortDirection: $sortDirection
    ) {
      items {
        cartaAviso
        contratoEmpresa
        contratoId
        createdAt
        cumplimientoRequisito
        dtIndex
        empresaId
        empresaId_pais_consecutivoOferta
        estadoActual
        estadoContrato
        estadoContratoAnpd
        fechaContrato
        hashRepLegal
        hashTrabajador
        historialEstados
        historialEstadosContrato
        historialEstadosContratoAnpd
        infoOnboardingLeida
        origenPostulacion
        pais_consecutivoOferta_trabajadorId
        pathContratos
        pathContratosCliente
        trabajadorId
        turnos
        turnosExtra
        updatedAt
        valorAPagar
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTrabajadorPagos = /* GraphQL */ `
  query ListTrabajadorPagos(
    $fecha_uuid: ModelStringKeyConditionInput
    $filter: ModelTrabajadorPagoFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $trabajadorId: String
  ) {
    listTrabajadorPagos(
      fecha_uuid: $fecha_uuid
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      trabajadorId: $trabajadorId
    ) {
      items {
        concepto
        createdAt
        empresaId_pais_consecutivoOferta
        fecha_uuid
        historialPagoId
        trabajadorId
        updatedAt
        valor
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTrabajadors = /* GraphQL */ `
  query ListTrabajadors(
    $correo: AWSEmail
    $filter: ModelTrabajadorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTrabajadors(
      correo: $correo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        activo
        banco
        calificacionPromedio
        calle
        canalesNotificaciones
        ciudad
        clave
        comuna
        correo
        createdAt
        depto
        descripcion
        direccion
        dni
        enlaceFoto
        estId
        fechaNacimiento
        firebaseToken
        idBanco
        nacionalidad
        noCuentaBancaria
        nombre
        numero
        origen
        pais
        primerApellido
        region
        segundaClave
        segundoApellido
        sexo
        telefono
        tipoCuenta
        ultimaFechaConsultaAnuncios
        updatedAt
        uuid
        validadoXEST
        validarDocumentos
        visibilidadFoto
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTrabajoFavoritos = /* GraphQL */ `
  query ListTrabajoFavoritos(
    $filter: ModelTrabajoFavoritoFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $trabajadorId: String
  ) {
    listTrabajoFavoritos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      trabajadorId: $trabajadorId
    ) {
      items {
        createdAt
        ofertasTrabajo
        trabajadorId
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTransaccions = /* GraphQL */ `
  query ListTransaccions(
    $empresaId: String
    $fecha_uuid: ModelStringKeyConditionInput
    $filter: ModelTransaccionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTransaccions(
      empresaId: $empresaId
      fecha_uuid: $fecha_uuid
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        correo
        createdAt
        detalle
        empresaId
        fecha_uuid
        monto
        observacion
        tipo
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUbicacionSupervisors = /* GraphQL */ `
  query ListUbicacionSupervisors(
    $correo: ModelStringKeyConditionInput
    $filter: ModelUbicacionSupervisorFilterInput
    $limit: Int
    $nextToken: String
    $pais_region_ciudad_comuna_uuid: String
    $sortDirection: ModelSortDirection
  ) {
    listUbicacionSupervisors(
      correo: $correo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_region_ciudad_comuna_uuid: $pais_region_ciudad_comuna_uuid
      sortDirection: $sortDirection
    ) {
      items {
        correo
        createdAt
        pais_region_ciudad_comuna_uuid
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUbicacions = /* GraphQL */ `
  query ListUbicacions(
    $empresaId: String
    $filter: ModelUbicacionFilterInput
    $limit: Int
    $nextToken: String
    $pais_region_ciudad_comuna_uuid: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    listUbicacions(
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      pais_region_ciudad_comuna_uuid: $pais_region_ciudad_comuna_uuid
      sortDirection: $sortDirection
    ) {
      items {
        activa
        codigoPostal
        createdAt
        direccion
        empresaId
        nombre
        pais_region_ciudad_comuna_uuid
        timezone
        ubicacion
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUsuarioBackoffices = /* GraphQL */ `
  query ListUsuarioBackoffices(
    $correo: AWSEmail
    $filter: ModelUsuarioBackofficeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsuarioBackoffices(
      correo: $correo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        activo
        cargo
        correo
        createdAt
        dni
        nombre
        telefono
        tipoUsuario
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUsuarioEmpresas = /* GraphQL */ `
  query ListUsuarioEmpresas(
    $correo: ModelStringKeyConditionInput
    $empresaId: String
    $filter: ModelUsuarioEmpresaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsuarioEmpresas(
      correo: $correo
      empresaId: $empresaId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        activo
        cargo
        clave
        correo
        createdAt
        dni
        empresaId
        nombre
        telefono
        tipoUsuario
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const trabajadorHabilidadesByTipoHabilidadAndFechaSolicitud = /* GraphQL */ `
  query TrabajadorHabilidadesByTipoHabilidadAndFechaSolicitud(
    $fechaSolicitud: ModelStringKeyConditionInput
    $filter: ModelTrabajadorHabilidadesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $tipoHabilidad: String!
  ) {
    trabajadorHabilidadesByTipoHabilidadAndFechaSolicitud(
      fechaSolicitud: $fechaSolicitud
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      tipoHabilidad: $tipoHabilidad
    ) {
      items {
        certificado
        correo
        createdAt
        estado
        fechaSolicitud
        habilidadId
        historialEstados
        infoAdicionalCertificado
        resultadoExamen
        tipoHabilidad
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const trabajadorOfertaByTrabajadorIdAndEmpresaIdPaisConsecutivoOferta = /* GraphQL */ `
  query TrabajadorOfertaByTrabajadorIdAndEmpresaIdPaisConsecutivoOferta(
    $empresaId_pais_consecutivoOferta: ModelStringKeyConditionInput
    $filter: ModelTrabajadorOfertaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $trabajadorId: String!
  ) {
    trabajadorOfertaByTrabajadorIdAndEmpresaIdPaisConsecutivoOferta(
      empresaId_pais_consecutivoOferta: $empresaId_pais_consecutivoOferta
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      trabajadorId: $trabajadorId
    ) {
      items {
        cartaAviso
        contratoEmpresa
        contratoId
        createdAt
        cumplimientoRequisito
        dtIndex
        empresaId
        empresaId_pais_consecutivoOferta
        estadoActual
        estadoContrato
        estadoContratoAnpd
        fechaContrato
        hashRepLegal
        hashTrabajador
        historialEstados
        historialEstadosContrato
        historialEstadosContratoAnpd
        infoOnboardingLeida
        origenPostulacion
        pais_consecutivoOferta_trabajadorId
        pathContratos
        pathContratosCliente
        trabajadorId
        turnos
        turnosExtra
        updatedAt
        valorAPagar
        __typename
      }
      nextToken
      __typename
    }
  }
`;
